module.exports = __webpack_public_path__ + "static/img/swiper2.e402ff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swiper2.png
// module id = E2ym
// module chunks = 0